import { useBillingServiceStore } from '@billing/AppProvider'
import { PackagesContainer } from '@billing/features/packaging/containers/PackagesContainer'
import { Container, Tab, Tabs } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { CommodityFilterUIStore } from '../stores/commodity-filter.ui-store'
import { CommodityListUIStore } from '../stores/commodity-list.ui-store'
import { CommoditiesContainer } from './CommoditiesContainer'

interface Props {
  commoditiesListStore: CommodityListUIStore
  commodityFilterStore: CommodityFilterUIStore
}
export const CommoditiesAndPackagingContainer = observer(
  ({ commoditiesListStore, commodityFilterStore }: Props) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const { commodityStore, catalogueStore, packageStore } = useBillingServiceStore()
    const [selectedTab, setSelectedTab] = useState<'commodity' | 'package'>('commodity')

    useEffect(() => {
      async function fetchData() {
        await Promise.all([
          commodityStore.loadAllWhenNotFetched(),
          catalogueStore.load(),
          packageStore.load(),
        ])

        catalogueStore.setSelectedCatalogueIdFromItems()
      }

      fetchData()
    }, [catalogueStore, commoditiesListStore, commodityStore, packageStore])

    const title = t('commoditiesAndPackaging', 'Commodities and Packaging')
    const breadcrumbs = [
      { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
      {
        label: title,
      },
    ]

    return (
      <>
        <Header title={title} breadcrumbs={breadcrumbs} />
        <Container sx={{ paddingY: theme.customSpacing.m }}>
          <Tabs
            value={selectedTab}
            onChange={(_, value) => setSelectedTab(value)}
            aria-label='basic tabs example'
          >
            <Tab label={t('commodities', 'Commodities')} value='commodity' />
            <Tab label={t('packages', 'Packages')} value='package' />
          </Tabs>
        </Container>

        {selectedTab === 'commodity' && (
          <CommoditiesContainer
            listStore={commoditiesListStore}
            filterStore={commodityFilterStore}
          />
        )}
        {selectedTab === 'package' && <PackagesContainer />}
      </>
    )
  },
)
